<template>
  <div class="search-wrapper">
    <div class="search-wrapper-overlay">
      <div class="search-bar-div">
        <h2>Search Knowledge Base</h2>
        <search-bar style="width:100%" class="ng-isolate-scope">
          <div class="search-bar">
            <div class="ng-isolate-scope search-bar-input">
              <div class="bar">
                <div action class="ng-pristine ng-valid">
                  <input
                    class="input ng-pristine ng-untouched ng-valid ng-empty"
                    type="search"
                    placeholder="Search"
                    @input="search"
                    v-model="searchQuery"
                    @click="showResults = true"
                    @blur="hideResults"
                    v-on:keyup.13="showAllResults"
                  />
                  <span class="icon search-icon" @click="showAllResults()" style="width: 34px;">
                    <i class="fas fa-search"></i>
                    <font-awesome-icon :icon="['fas', 'search']" />
                  </span>
                </div>
              </div>
              <nav class="results ng-hide" ng-show="isOpen" aria-hidden="true">
                <!-- ngRepeat: hit in hits -->
              </nav>
            </div>
          </div>
          <div class="search-results" v-if="searchResults.length > 0 && showResults">
            <b-list-group>
              <router-link
                v-for="result in limitedSearchResults"
                :key="result.url"
                :to="{path: result.url }"
              >
                <b-list-group-item>
                  <span class="product-icon">
                    <img :src="result.productIcon" />
                  </span>
                  <span v-if="result.articleName">
                    <strong>{{result.articleName}}</strong>
                    <br />
                    <span class="small-text">
                      {{result.productName}} {{result.appName == 0 ? '' : '- ' + result.appName}}
                      <span
                        v-if="result.sectionName.length > 0"
                      >- {{result.sectionName}}</span>
                    </span>
                  </span>
                  <span v-else-if="result.sectionName">
                    <strong>{{result.sectionName}}</strong>
                    <br />
                    <span class="small-text">{{result.productName}} {{result.appName == 0 ? '' : '- ' + result.appName}}</span>
                  </span>
                  <span v-else-if="result.appName">
                    <strong>{{result.appName}}</strong>
                    <br />
                    <span class="small-text">{{result.productName}}</span>
                  </span>
                  <span v-else>
                    <strong>{{result.productName}}</strong>
                  </span>
                </b-list-group-item>
              </router-link>
              <div class="show-all-results-button" v-if="searchResults.length > 5" @click="showAllResults">
                <b-list-group-item>
                  <span class="product-icon"></span>
                  <span>Show all results</span>
                </b-list-group-item>
              </div>
            </b-list-group>
          </div>
        </search-bar>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SearchBarComponent',
  data() {
    return {
      searchResults: [],
      searchQuery: '',
      showResults: false
    };
  },
  computed: {
    limitedSearchResults() {
      return this.searchResults.slice(0, 5);
    }
  },
  methods: {
    hideResults() {
      setTimeout(() => {
        this.showResults = false;
      }, 200);
    },
    search() {
      this.showResults = true;
      axios
        .get(
          process.env.VUE_APP_BASE_URL +
            '/' +
            'search?query=' +
            this.searchQuery +
            '&limit=6&getProductList=false'
        )
        .then(response => {
          this.searchResults = response.data.results;
        });
    },
    showAllResults() {
      this.showResults = false;
      this.$router.push({
        path: '/search?query=' + this.searchQuery
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nuiteq-button {
  width: 100%;
  margin-bottom: 5px;
}

a {
  color: inherit;
  text-decoration: none;
}

a:hover {
  color: inherit;
  text-decoration: none;
}

div.search-wrapper-overlay {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: relative;
}

.small-text {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  color: rgb(34, 34, 34) !important;
  font-size: 12px !important;
  line-height: 16px !important;
  font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto,
    Helvetica Neue, sans-serif !important;
  font-weight: 400 !important;
}

.product-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

h2 {
  color: white;
  font-size: 56px;
  margin-bottom: 20px;
}

div.search-results {
  position: absolute;
  width: 100%;
  z-index: 10;
}

.list-group {
  width: 580px;
  margin: auto;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  background-color: #fff;
  margin-top: 3.5px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.26);
  overflow: hidden;
  text-align: left;
}

.list-group-item {
  padding: 0.55rem 1.25rem;
  padding-left: 42px;
  border-radius: 0px;
}

.list-group-item:hover {
  outline: none;
  border-color: #ef9743;
  box-shadow: 2px 0 3px #ef9743;
}

.admin-button {
  position: relative;
  z-index: 0;
}

.list-group-item img {
  max-height: 100%;
  width: 22px;
  margin-right: 12px;
}

.search-bar-div {
  position: absolute;
  top: 50%;
  z-index: 2;
  left: 50%;
  transform: translate(-50%, -50%);
  padding-bottom: 18px;
}

.card-img-top {
  width: 140px;
  margin: auto;
}
.add-card > img:nth-child(1) {
  width: 158px;
}
.card-title {
  text-align: center;
}
.card {
  padding-top: 24px;
  transition: all 0.3s ease;
  border: none;
  border: 1px solid rgba(0, 0, 0, 0);
}
.card:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 30px 0;
  border: 1px solid #ef9743;
}
div.search-wrapper {
  height: 280px;
  background-color: orange;
  text-align: center;
  background-image: url("~@/assets/images/support_top_bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
}

.svg-inline--fa {
  width: 46px;
  height: 28px;
  margin-top: 6px;
}

div.search-bar-input {
  text-align: left;
  display: inline-block;
  flex: 1 1 650px;
  line-height: 40px;
  position: relative;
}

input.input::-ms-clear {
  display: none;
}

/* clears the 'X' from Internet Explorer */
input.input::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
input.input::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the 'X' from Chrome */
input.input::-webkit-search-decoration,
input.input::-webkit-search-cancel-button,
input.input::-webkit-search-results-button,
input.input::-webkit-search-results-decoration {
  display: none;
}

div.search-bar-input {
  text-align: left;
  line-height: 40px;
}

div.search-bar-input .input {
  line-height: 20px;
  height: 60px;
  max-width: 100%;
  border-radius: 4px;
  padding: 0 70px 0 36px;
  box-shadow: 0 8px 18px 0 rgba(10, 73, 89, 0.1);
  border: 1px solid #e4e4e4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 580px;
}

div.search-bar-input .input:focus {
  outline: none;
  border-color: #ef9743;
  box-shadow: 0 0 3px #ef9743;
}

.show-all-results-button:hover {
  cursor: pointer;
}

questions .search-bar .bar .input {
  background-color: #fff;
  font-family: CiscoSansTT Light, Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #9e9fa2;
  width: 820px;
}
div.search-bar-input .icon {
  padding: 0;
  position: absolute;
  right: 31px;
  top: 10px;
}

.search-icon:hover {
  cursor: pointer;
}

@media (max-width: 767px) {
  div.search-bar-input .input {
    width: 350px;
  }
  .list-group {
    width: 350px;
  }
  h2 {
    font-size: 36px;
  }
  .list-group-item {
    outline: none;
    border-color: #ef9743;
    box-shadow: 2px 0 3px #ef9743;
  }

  .list-group-item:hover {
    outline: none;
    border-color: #ef9743;
    box-shadow: 2px 0 3px #ef9743;
  }
}
</style>
